var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconElk = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.55 18.645-1.953-.154a2.347 2.347 0 0 1-.759-.211l-4.792-2.207a3.232 3.232 0 0 1-.886-.618l-1.728-1.7a1.996 1.996 0 0 1-.66-1.321l-.113-3.415a2.81 2.81 0 0 1 .183-1.125c.239-.576 1.405-3.724 1.574-4.145a.52.52 0 0 0-.24-.703.534.534 0 0 0-.702.267l-1.911 3.556a.281.281 0 0 1-.38.126c-.21-.084-.955-.464-1.7-.815L6.81 5.35a.576.576 0 0 0-.76.198.534.534 0 0 0 .225.716l1.406.942c.787.562 1.7 1.194 1.94 1.405a.703.703 0 0 1 .308.562c0 .225.14 2.15.169 3.022a.365.365 0 0 1 0 .267.422.422 0 0 1-.351 0l-5.959-1.715a.576.576 0 0 0-.773.323.59.59 0 0 0 .408.703c.45.169 5.621 2.136 6.45 2.431.185.08.352.194.492.338l2.094 2.122a.253.253 0 0 1 0 .182l-.843.745a1.25 1.25 0 0 1-.76.127c-.393 0-3.4-.45-3.442-.464a.562.562 0 0 0-.647.45.548.548 0 0 0 .464.618l3.626.871c.43.14.892.14 1.32 0l2.01-.97a.787.787 0 0 1 .69 0c.407.17 1.404.633 2.964 1.406a.885.885 0 0 1 .436.52.857.857 0 0 1-.098.646l-.548.787a.843.843 0 0 1-.464.296l-1.813.323a.478.478 0 0 0 0 .941H17.758c.42-.058.796-.287 1.04-.632l1.405-1.757a.436.436 0 0 1 .366-.154h1.855c.38 0 .548-.169.576-.548v-.956a.478.478 0 0 0-.45-.45z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconElk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-elk.737fc84f.svg";
export { ForwardRef as ReactComponent };